export const queryKeys = {
  fetchContentTypePermissions: 'fetchContentTypePermissions' as const,
  fetchFundamentals: (companyId: string) => ['fundamentals', companyId] as const,
};
